// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\nheader {\n  position: fixed;\n  z-index: 10;\n  top: 0;\n  left: 0;\n  right: 0;\n  background-color: #fff;\n  height: 64px;\n  min-width: 1400px;\n  padding-left: 35px;\n  padding-right: 40px;\n  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.08);\n}\n", ""]);
// Exports
module.exports = exports;
